import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IAboutSchoolResponse, TAboutSchoolPayload } from './types';

export const aboutSchoolService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить данные блока "О школе"
     */
    getAboutSchool: builder.query<UnwrapData<IAboutSchoolResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/about_school`,
      }),
      transformResponse: (response: IAboutSchoolResponse): UnwrapData<IAboutSchoolResponse> => response.data,
      providesTags: ['MainPageAboutSchool'],
    }),
    /**
     * Создать данные блока "О школе"
     */
    createAboutSchool: builder.mutation<UnwrapData<IAboutSchoolResponse>, { id: number; data: TAboutSchoolPayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/about_school`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAboutSchoolResponse): UnwrapData<IAboutSchoolResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageAboutSchool'],
    }),
    /**
     * Обновить данные блока "О школе"
     */
    updateAboutSchool: builder.mutation<UnwrapData<IAboutSchoolResponse>, { id: number; data: TAboutSchoolPayload }>({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${id}/about_school`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAboutSchoolResponse): UnwrapData<IAboutSchoolResponse> => response.data,
      invalidatesTags: ['MainPageAboutSchool'],
    }),
  }),
});

export const { useGetAboutSchoolQuery, useCreateAboutSchoolMutation, useUpdateAboutSchoolMutation } =
  aboutSchoolService;
